import {useContext, useEffect, useState} from "react";
import EditQRCodeContext from "./EditQRCodeContext";
import {Button, FileInput, Stack, TextInput} from "@mantine/core";
import EditQRCodePayload from "../../../api/qr-code/EditQRCodePayload";
import PdfAttachmentApi from "../../../api/pdf-attachment/PdfAttachmentApi";
import PdfAttachment from "../../../api/pdf-attachment/PdfAttachment";
import QRCodeApi from "../../../api/qr-code/QRCodeApi";
import {useNavigate} from "react-router-dom";
import {useForm} from "@mantine/form";
import QRCodeContext from "../../../contexts/qr-code/QRCodeContext";

type _FormType = Pick<EditQRCodePayload, "name">;

export const PDFEditForm = () => {
    const { qrCode } = useContext(EditQRCodeContext);
    const nav = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(false);
    const { reload } = useContext(QRCodeContext);
    const [file, setFile] = useState<File | null>();
    const form = useForm<_FormType>({
        initialValues: {
            name: ""
        }
    })

    const onSubmit = (values: _FormType) => {
        setLoading(true);

        if (file) {
            PdfAttachmentApi.create({file})
            .then(async (pdf: PdfAttachment) => {
                if (!qrCode) {
                    throw new Error("QRCode is not defined");
                }

                await QRCodeApi.editById(qrCode.id, {name: values.name, pdfAttachment: pdf.id});
                reload();
                return nav(-1);
            })
            .finally(() => setLoading(false));
        }

        else {
            if (!qrCode) {
                throw new Error("QRCode is not defined");
            }

            QRCodeApi.editById(qrCode.id, {name: values.name})
                .then(() => reload())
                .then(() => nav(-1))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        form.setValues({
            name: qrCode?.name ?? ""
        })
        // eslint-disable-next-line
    }, [qrCode]);

    return (
        <form onSubmit={form.onSubmit(onSubmit)}>
            <Stack>
                <TextInput
                    required
                    placeholder="Nazwa kodu QR"
                    {...form.getInputProps('name')}
                />

                <FileInput
                    accept="application/pdf"
                    placeholder="Plik PDF"
                    description="Jeśli nie chcesz zmienić pliku, pozostaw puste pole."
                    onChange={setFile}
                    value={file}
                />

                <Button type="submit" loading={isLoading}>
                    Zapisz
                </Button>
            </Stack>
        </form>
    )
}